import React, { useMemo } from 'react';
import clsx from 'clsx';
import { ClassroomStudent } from '../boutique-classroom.types';
import { MAX_VISIBLE_AVATARS } from '../boutique-classroom.constants';

interface AvatarStackProps {
	students: ClassroomStudent[];
	maxVisible?: number;
	showOverflow?: boolean;
	size?: 'small' | 'medium';
	className?: string;
}

const AVATAR_TONE_COUNT = 4;

function getInitials(fullName: string): string {
	return fullName
		.trim()
		.split(/\s+/)
		.slice(0, 2)
		.map(part => part.charAt(0).toLocaleUpperCase('tr-TR'))
		.join('');
}

export const AvatarStack: React.FC<AvatarStackProps> = ({ students, maxVisible = MAX_VISIBLE_AVATARS, showOverflow = true, size = 'medium', className }) => {
	const visible = useMemo(() => students.slice(0, maxVisible), [students, maxVisible]);
	const overflow = students.length - visible.length;

	return (
		<div className={clsx('avatar-stack', `avatar-stack--${size}`, className)}>
			{visible.map((student, index) => (
				<span
					key={student.id}
					className={clsx('avatar-stack__item', `avatar-stack__item--tone-${index % AVATAR_TONE_COUNT}`)}
					title={student.fullName}>
					{getInitials(student.fullName)}
				</span>
			))}
			{showOverflow && overflow > 0 && <span className="avatar-stack__item avatar-stack__item--overflow">+{overflow}</span>}
		</div>
	);
};

export default AvatarStack;
